interface SuportModalProps {
  onClose: () => void;
}

function SupportModal({ onClose }: SuportModalProps) {
  return (
    <section className="text-black fixed top-0 left-0 z-50 w-full h-screen bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white w-[38rem] h-fit md:h-[14rem] flex flex-col gap-8 justify-between shadow-sm rounded px-6 py-4">
        <div className="flex flex-col items-center gap-4">
          <div className="text-lg font-semibold">
            Depending on your region contact the appropriate support:
          </div>
          <div>
            <div className="flex items-center gap-2">
              <div className="font-semibold">US -</div>
              <div className="underline">onesearch_us@publicismedia.com</div>
            </div>
            <div className="flex items-center gap-2">
              <div className="font-semibold">EMEA -</div>
              <div className="underline">onesearch_emea@performics.com</div>
            </div>
            <div className="flex items-center gap-2">
              <div className="font-semibold">Global -</div>
              <div className="underline">onesearch_global@performics.com</div>
            </div>
          </div>
        </div>
        <div className="flex justify-center items-center font-medium">
          <div
            onClick={() => onClose()}
            className="w-1/4 bg-black text-white rounded-full flex justify-center items-center py-1 sm:py-1.5 cursor-pointer select-none"
          >
            CLOSE
          </div>
        </div>
      </div>
    </section>
  );
}

export default SupportModal;
